// @flow
import React from 'react';
import Progress from 'redux-progress';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { colors } from '@atlaskit/theme';
import t from 'modules/i18n/intl';

import type { State } from 'model/State';
import type { UserDetails } from 'modules/auth/model/UserDetails';
import Link from 'components/common/Link';
import { Font, Dimensions } from 'components/visuals';
import config from 'appconfig';

type Props = {
  userDetails: Progress<UserDetails | null>,
};

const Wrapper = styled.div`
  color: ${colors.N500};
  font-family: ${Font.family};
  font-size: 12px;
  height: ${Dimensions.units(2)}px;
  text-align: right;
`;

const LoggedInStatus = (props: { userDetails: UserDetails }) => (
  <Wrapper>
    <Link to={config.macUrl} className="pii">
      {props.userDetails.displayName || t('navigation.header.my-account')}
    </Link>
    <span>
      {' '}
      (<Link to={config.logoutUrl()}>{t('navigation.header.logout')}</Link>)
    </span>
  </Wrapper>
);

const AnonymousStatus = () => (
  <Wrapper>
    <Link to={config.macUrl}>{t('navigation.header.my-account')}</Link>
  </Wrapper>
);

export const VisualLoginStatus = (props: Props) =>
  props.userDetails.ifSuccess(
    (userDetails) => userDetails && <LoggedInStatus userDetails={userDetails} />,
  ) || <AnonymousStatus />;

const mapStateToProps = (state: State): Props => ({
  userDetails: state.auth.userDetails,
});

export default connect(mapStateToProps)(VisualLoginStatus);
